import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import { HolidayCalendarScreen } from '@/features/platform-holidays/holiday-calendar-screen'

const holidaysSearchSchema = z.object({
  country: z.string().optional(),
  year: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/settings/holidays')({
  validateSearch: holidaysSearchSchema,
  component: HolidaysRoute,
})

/** The authenticated layout is the platform-admin guard for this section. */
function HolidaysRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()

  return (
    <HolidayCalendarScreen
      country={search.country ?? 'EG'}
      year={search.year ?? String(new Date().getFullYear())}
      onFilterChange={(patch) => {
        void navigate({
          to: '/settings/holidays',
          search: { ...search, ...patch },
          replace: true,
        })
      }}
    />
  )
}
